export enum AddFileNavigationPositionEnum{
    uploading = 0,
    index = 1,
    sendFile = 2,
    sendLink = 3,
    verifyFile = 4,
    chooseViewType=5
}

 